import React, { useContext } from "react";
import { AppContext } from "../AppProvider";

function useSnackBar() {
  const { state, setState } = useContext(AppContext);

  function setSnackBar({ message, type }) {
    let sanckBar = {
      sanckBar: {
        type: type,
        message: message,
      },
    };
    setState((prev) => {
      return {
        ...prev,
        ...sanckBar,
      };
    });
  }

  return {
    snackBar: state.sanckBar,
    setSnackBar,
  };
}

export default useSnackBar;
